const mock = {
  // description: [
  //   {
  //     label: 'Vazão',
  //     color: (props) => props.theme.colors.graphIntensity1,
  //     value: 1500,
  //   },
  //   {
  //     label: 'Temperatura',
  //     color: (props) => props.theme.colors.graphIntensity2,
  //     value: 700,
  //   },
  //   {
  //     label: 'Pressão',
  //     color: (props) => props.theme.colors.graphIntensity3,
  //     value: 600,
  //   },
  //   {
  //     label: 'Potência',
  //     color: (props) => props.theme.colors.graphIntensity4,
  //     value: 550,
  //   },
  //   {
  //     label: 'Corrente',
  //     color: (props) => props.theme.colors.graphIntensity5,
  //     value: 450,
  //   },
  //   {
  //     label: 'Vibração',
  //     color: (props) => props.theme.colors.graphIntensity5,
  //     value: 300,
  //   },
  //   {
  //     label: 'Energia gerada',
  //     color: (props) => props.theme.colors.graphIntensity5,
  //     value: 250,
  //   },
  //   {
  //     label: 'Fator de serviço',
  //     color: (props) => props.theme.colors.graphIntensity5,
  //     value: 100,
  //   },
  // ],

  data: [
    {
      name: 'vazao',
      value: 1500,
    },
    {
      name: 'temperatura',
      value: 700,
    },
    {
      name: 'pressao',
      value: 300,
    },
    {
      name: 'potencia',
      value: 150,
    },
    {
      name: 'corrente',
      value: 450,
    },
    {
      name: 'vibracao',
      value: 500,
    },
    {
      name: 'energiaGerada',
      value: 550,
    },
    {
      name: 'fatorServico',
      value: 600,
    },
  ],
};

export default mock;
